<template>
    <div>
        <div v-for="each, i in copyReplies" :key="i + 'reply'">
            <div :style="{ background: setBackgroundColor(each) }" :class="{ 'active_reply': each.idx === curCommentReplyIdx }" class="common_reply_item">
                <div style="display: flex; gap: 8px;">
                    <div style="width: 40px; height: 40px;" @click="$Util.showProfile(each.writer_idx, each.writer_type)">
                        <ProfileImage style="width: 40px; height: 40px;" :image-path="each.image_path"></ProfileImage>
                    </div>
                    <div v-if="each.type !== SOCCER_HOW_TYPE.SINGLE_TRAINING && each.type !== SOCCER_HOW_TYPE.GROUP_TRAINING" style="flex: 1;">
                        <div style="font-weight: 700; font-size: 12px; line-height: 24px; display:flex; align-items: center;" @click="$Util.showProfile(each.writer_idx, each.writer_type)">
                            {{ each.nic_name }}
                            <template v-if="each.writer_is_coach == '1'">
                                <img v-if="each.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/blue_star.png')" alt="">
                                <img v-else style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/yellow_star.png')" alt="">
                            </template>
                            <span v-else style="font-weight: 900; font-size: 11px; margin-left: 4px; color: var(--color-main);">
                                <DivisionPositionText :position="each.position" :positionProAbility="each.position_pro_ability"></DivisionPositionText>
                            </span>
                            <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%; margin: 0 4px;"></div>
                            <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; text-align: right;">{{ each.insert_date | agoDateStr }}</div>
                        </div>
                        <div style="font-weight: 500; font-size: 15px; line-height: 24px; white-space: pre-line; word-break: break-all;">{{ each.contents }}</div>
                        <div v-if="each.update_date && each.insert_date !== each.update_date" style="font-weight: 400; font-size: 12px; line-height: 18px; color: #808080; margin-top: 2px;">수정됨</div>
                    </div>
                    <div style="flex: 1; display: flex; justify-content: space-between;" v-else>
                        <div style="font-weight: 700; font-size: 14px; line-height: 24px; display:flex; align-items: center;" @click="showTrainingDetail(each.idx)">
                            {{ each.nic_name }}
                            <span style="font-weight: 900; font-size: 11px; margin-left: 2px; color: var(--color-main);">
                                <DivisionPositionText :position="each.position" :positionProAbility="each.position_pro_ability"></DivisionPositionText>
                            </span>
                            님이 훈련을 완료했어요!
                            <!-- <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%; margin: 0 4px;"></div> -->
                        </div>
                        <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; flex: 1; text-align: right;">{{ $Util.getMDDHangulStr(each.insert_date) }}</div>
                    </div>
                </div>
                <div v-if="each.type !== SOCCER_HOW_TYPE.SINGLE_TRAINING && each.type !== SOCCER_HOW_TYPE.GROUP_TRAINING" style="display: flex; gap: 24px; justify-content: flex-end; margin-top: 12px;">
                    <div v-if="!isHideOption" @click.stop="() => { }" @touchstart.stop="touchStart(i)" @touchend.stop="touchEnd(i, -1, false, each.idx)" style="display: flex; gap: 5px; align-items: center; ">
                        <div style="position: relative;">
                            <img :style="{ opacity: each.like_yn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                            <img style="width: 16px; position: relative; z-index: 2;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                            <!-- <img v-else style="width: 16px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt=""> -->
                        </div>
                        <div style="font-weight: 700; font-size: 12px;">{{ each.like_number }}</div>
                    </div>
                    <div v-if="!isHideOption" @click="setReplyIdx(each)" style="display: flex; gap: 5px; align-items: center;">
                        <img style="width: 16px;" :src="require('@/assets/img/feed_reply.png')" alt="">
                        <div style="font-weight: 700; font-size: 12px;">{{ each.reply_number }}</div>
                    </div>
                    <div @click="showPopupMenu(each)" style="display: flex; gap: 2px; align-items: center;">
                        <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                        <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                        <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                    </div>
                </div>
                <div style="border-left: 2px solid #EBEBEB; padding-left: 10px; margin-top: 16px;" v-if="each.childReplies">
                    <div v-for="childReply, childIndex in each.childReplies" style="margin-top: 16px;" :key="childIndex + 'child'">
                        <div style="display: flex; gap: 8px;">
                            <div style="width: 40px; height: 40px;" @click="$Util.showProfile(childReply.writer_idx, childReply.writer_type)">
                                <ProfileImage style="width: 40px; height: 40px;" :image-path="childReply.image_path"></ProfileImage>
                            </div>
                            <div>
                                <div style="font-weight: 700; font-size: 12px; line-height: 24px; display:flex; align-items: center;" @click="$Util.showProfile(childReply.writer_idx, childReply.writer_type)">
                                    {{ childReply.nic_name }}
                                    <template v-if="childReply.writer_is_coach == '1'">
                                        <img v-if="childReply.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="margin-left:5px;width: 13px; vertical-align: bottom;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </template>
                                    <span v-else style="font-weight: 900; font-size: 11px; margin-left: 4px; color: var(--color-main);">{{ childReply.position }}</span>
                                    <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%; margin: 0 4px;"></div>
                                    <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060;">{{ childReply.insert_date | agoDateStr }}</div>
                                </div>
                                <div style="font-weight: 500; font-size: 15px; line-height: 24px;"><span style="color: #bbbbbb; margin-right: 4px;"> @{{ each.nic_name }}</span>{{ childReply.contents }}</div>
                                <div v-if="childReply.update_date && childReply.insert_date !== childReply.update_date" style="font-weight: 400; font-size: 12px; line-height: 18px; color: #808080; margin-top: 2px;">수정됨</div>
                            </div>
                        </div>
                        <div style="display: flex; gap: 24px; justify-content: flex-end; margin-top: 12px;">
                            <div @click.stop="() => { }" @touchstart.stop="touchStart(i, childIndex, true)" @touchend.stop="touchEnd(i, childIndex, true, childReply.idx)" style="display: flex; gap: 5px; align-items: center; ">
                                <div style="position: relative;">
                                    <img :style="{ opacity: childReply.like_yn === IS_LIKE.LIKE ? '1' : '0' }" :ref="'shoot_child_' + i + '_' + childIndex" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                                    <img style="width: 16px; position: relative; z-index: 2;" :ref="'soccerBall_child_' + i + '_' + childIndex" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                                    <!-- <img v-else style="width: 16px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt=""> -->
                                </div>
                                <div style="font-weight: 700; font-size: 12px;">{{ childReply.like_number }}</div>
                            </div>
                            <div @click="showPopupMenu(childReply, true, each)" style="display: flex; gap: 2px; align-items: center;">
                                <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                                <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                                <div style="width: 4px; height: 4px; background-color: #606060; border-radius: 50%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="i !== copyReplies.length - 1" style="height: 1px; background-color: #d9d9d9;"></div> -->
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <SoccerHowReplyUpdatePopup :isChildReply="isChildReply" :myInfo="myInfo" :opponentInfo="opponentInfo" :signal-open="isOpenReplyPopup" :soccerhow_idx="curReplyUpdateSoccerHowIdx" :complete-action="completeAction" />
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import SoccerHowReplyUpdatePopup from "@/components/soccerhow/SoccerHowReplyUpdatePopup";
import { TEAM_TYPE, SOCCER_HOW_TYPE, MAIN_TYPE } from '@/Constants'
import DivisionPositionText from '@/components/common/DivisionPositionText'

const IS_LIKE = {
    LIKE: '1',
    UNLIKE: '0'
}

export default {
    name: 'CommonReply',
    components: {
        ProfileImage, BottomPopupMenu, SoccerHowReplyUpdatePopup, DivisionPositionText
    },
    props: {
        soccerhowIdx: {
            type: [String, Number],
            default: -1
        },
        setReplyIdx: {
            type: Function,
            default: () => { }
        },
        curCommentReplyIdx: {
            type: [String, Number],
            default: -1
        },
        replies: {
            type: Array,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        isHideOption: {
            type: Boolean,
            default: false
        },
        poll_idx: {
            type: Number,
            default: -1
        },
        is_banner: {
            type: Boolean,
            default: false
        },
        refer_idx: {
            type: Number,
            default: -1
        }
    },
    computed: {
        copyReplies() {
            return this.replies
        }
    },
    data() {
        return {
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            MAIN_TYPE: MAIN_TYPE,
            IS_LIKE: IS_LIKE,
            isShowPopMenu: false,
            menuOptions: {},
            isActiveCommentReply: false,
            isOpenReplyPopup: false,
            curReplyUpdateSoccerHowIdx: -1,
            myInfo: {},
            opponentInfo: {},
            isChildReply: false,
            TEAM_TYPE: TEAM_TYPE
        }
    },
    methods: {
        showTrainingDetail(idx) {
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: idx })
        },
        setBackgroundColor(item) {
            if (item.type !== SOCCER_HOW_TYPE.SINGLE_TRAINING && item.type !== SOCCER_HOW_TYPE.GROUP_TRAINING) {
                return '#f5f5f5'
            } else {
                return 'linear-gradient(0deg, #FFEADC, #FFEADC)'
            }
            // each.idx === curCommentReplyIdx ? '#fff8f4' : '#f5f5f5'
        },
        async deleteReply(idx) {
            if (confirm('댓글을 삭제하시겠습니까?')) {
                const res = await this.$Axios.post('/api/soccerhow/delete', { deleteList: [idx], poll_idx: this.poll_idx, is_banner: this.is_banner });

                if (res.data.code === 0) {
                    this.completeAction()
                }
            }
        },
        showPopupMenu(repliesInfo, isChildReply = false, opponentInfo) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            const isMeCreator = repliesInfo.writer_idx === this.$GlobalStore.loginInfo().idx ? true : false
            this.isShowPopMenu = true
            const labelAndAction = []
            if (isMeCreator) {
                labelAndAction.push(
                    {
                        label: '수정하기', action: () => {
                            console.log(opponentInfo)
                            this.myInfo = repliesInfo
                            this.isChildReply = isChildReply
                            this.opponentInfo = opponentInfo
                            this.isOpenReplyPopup = !this.isOpenReplyPopup
                            this.curReplyUpdateSoccerHowIdx = repliesInfo.idx
                            this.isShowPopMenu = false;
                        },
                    },
                    {
                        label: '삭제하기', action: () => {
                            this.deleteReply(repliesInfo.idx)
                            this.isShowPopMenu = false;
                        },
                        color: 'var(--color-main)'
                    }
                );
            } else {
                if (!isChildReply && !this.isHideOption) {
                    labelAndAction.push(
                        {
                            label: '답글 달기', action: () => {
                                this.setReplyIdx(repliesInfo)
                                this.isShowPopMenu = false
                            },
                        }
                    )
                }
                labelAndAction.push(
                    {
                        label: '댓글 신고', action: () => {
                            // this.report()
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        touchStartChildReply(index, childIndex) {
            if (!this.$GlobalStore.isLogin()) {
                return
            }
            const refName = `soccerBall_child_${index}_${childIndex}`;
            const element = this.$refs[refName]?.[0];

            if (!element) return;

            if (this.copyReplies[index].childReplies[childIndex].like_yn === IS_LIKE.UNLIKE) {
                element.style.transform = 'rotate(-180deg)';
                element.style.transition = 'all 0.3s';
            }
        },
        touchEndChildReply(index, childIndex, idx) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            const soccerRef = `soccerBall_child_${index}_${childIndex}`;
            const shootRef = `shoot_child_${index}_${childIndex}`;
            const soccerElement = this.$refs[soccerRef]?.[0];
            const shootElement = this.$refs[shootRef]?.[0];

            if (!soccerElement || !shootElement) return;
            if (this.copyReplies[index].childReplies[childIndex].like_yn === IS_LIKE.UNLIKE) {
                soccerElement.style.transition = 'all 0.3s';
                soccerElement.style.transform = 'rotate(0)';
                shootElement.style.opacity = '1';
                shootElement.style.transition = 'all 0.3s';
            } else {
                shootElement.style.transition = '';
                shootElement.style.opacity = '0';
            }
            const curLikeNumber = parseInt(this.copyReplies[index].childReplies[childIndex].like_number)
            let likeTemp = this.copyReplies[index].childReplies[childIndex].like_yn === IS_LIKE.UNLIKE ? '1' : '0'
            let likeNumber = this.copyReplies[index].childReplies[childIndex].like_yn === IS_LIKE.UNLIKE ? curLikeNumber + 1 : curLikeNumber - 1
            this.$set(this.copyReplies[index].childReplies[childIndex], 'like_yn', likeTemp);
            this.$set(this.copyReplies[index].childReplies[childIndex], 'like_number', likeNumber);
            this.toggleReplyLike(likeTemp, idx)
        },
        touchStart(index, childIndex, isChildReply) {
            if (!this.$GlobalStore.isLogin()) {
                return
            }
            if (isChildReply) {
                this.touchStartChildReply(index, childIndex)
                return
            }

            if (this.copyReplies[index].like_yn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall[index].style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall[index].style.transition = 'all 0.3s'
            }
        },
        touchEnd(index, childIndex, isChildReply, idx) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (isChildReply) {
                this.touchEndChildReply(index, childIndex, idx)
                return
            }

            if (this.copyReplies[index].like_yn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall[index].style.transition = 'all 0.3s'
                this.$refs.soccerBall[index].style.transform = 'rotate(0)'
                this.$refs.shoot[index].style.opacity = '1'
                this.$refs.shoot[index].style.transition = 'all 0.3s'
            } else {
                this.$refs.shoot[index].style.transition = ''
                this.$refs.shoot[index].style.opacity = '0'
            }
            const curLikeNumber = parseInt(this.copyReplies[index].like_number)
            let likeTemp = this.copyReplies[index].like_yn === IS_LIKE.UNLIKE ? '1' : '0'
            let likeNumber = this.copyReplies[index].like_yn === IS_LIKE.UNLIKE ? curLikeNumber + 1 : curLikeNumber - 1
            this.$set(this.copyReplies[index], 'like_yn', likeTemp);
            this.$set(this.copyReplies[index], 'like_number', likeNumber);
            this.toggleReplyLike(likeTemp, idx)
        },
        async toggleReplyLike(likeTemp, idx) {
            const parameters = {};
            parameters.likeYn = likeTemp;
            parameters.idx = idx;
            const res = await this.$Axios.post('/api/soccerhow/like', parameters);
            if (res.data.code === -1) {
                alert(res.data.msg);
            }
        }
    },
}
</script>

<style scoped>
.common_reply_item {
    padding: 12px;
    position: relative;
    margin-bottom: 10px;
    padding-bottom: 16px;
    padding-top: 12px;
    margin-top: 10PX;
    border-radius: 12px;
}

.active_reply {
    background: #fff8f4 !important;
}
</style>